/* ==========================================================================
   RegXperts — theme interactions
   Header, drawer, search, mega-menu, accordions, carousels, reveal
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;

  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* ---------- Sticky header shadow ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var lastKnown = false;
    function update() {
      var scrolled = window.scrollY > 12;
      if (scrolled !== lastKnown) {
        header.classList.toggle('is-scrolled', scrolled);
        lastKnown = scrolled;
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Mega menu (desktop) keyboard + click ---------- */
  function initMegaMenu() {
    $$('[data-nav-item]').forEach(function (item) {
      var trigger = $('[data-nav-trigger]', item);
      if (!trigger) return;
      on(trigger, 'click', function (e) {
        if (window.innerWidth <= 990) return;
        e.preventDefault();
        var open = item.classList.contains('is-open');
        $$('[data-nav-item]').forEach(function (i) { i.classList.remove('is-open'); });
        item.classList.toggle('is-open', !open);
      });
    });
    on(doc, 'click', function (e) {
      if (!e.target.closest('[data-nav-item]')) {
        $$('[data-nav-item]').forEach(function (i) { i.classList.remove('is-open'); });
      }
    });
    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape') {
        $$('[data-nav-item]').forEach(function (i) { i.classList.remove('is-open'); });
      }
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    var overlay = $('[data-drawer-overlay]');
    var openBtn = $('[data-drawer-open]');
    var closeEls = $$('[data-drawer-close]');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      doc.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      doc.body.style.overflow = '';
    }
    on(openBtn, 'click', openDrawer);
    closeEls.forEach(function (el) { on(el, 'click', closeDrawer); });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    /* Sub-menu accordions inside drawer */
    $$('[data-drawer-sub-toggle]', drawer).forEach(function (btn) {
      on(btn, 'click', function () {
        var sub = btn.nextElementSibling;
        btn.classList.toggle('is-open');
        if (sub) sub.classList.toggle('is-open');
      });
    });
  }

  /* ---------- Search panel ---------- */
  function initSearch() {
    var panel = $('[data-search-panel]');
    var openBtn = $('[data-search-open]');
    var closeBtn = $('[data-search-close]');
    if (!panel) return;
    function openPanel() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      var input = $('input[type="search"]', panel);
      if (input) setTimeout(function () { input.focus(); }, 240);
    }
    function closePanel() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }
    on(openBtn, 'click', openPanel);
    on(closeBtn, 'click', closePanel);
    on(doc, 'keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    $$('[data-faq-item]').forEach(function (item) {
      var q = $('[data-faq-q]', item);
      var a = $('[data-faq-a]', item);
      if (!q || !a) return;
      on(q, 'click', function () {
        var open = item.classList.contains('is-open');
        var group = item.closest('[data-faq]');
        if (group) {
          $$('[data-faq-item]', group).forEach(function (i) {
            i.classList.remove('is-open');
            var ans = $('[data-faq-a]', i);
            if (ans) ans.style.maxHeight = null;
            var qb = $('[data-faq-q]', i);
            if (qb) qb.setAttribute('aria-expanded', 'false');
          });
        }
        if (!open) {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- Carousels (hero + testimonials etc.) ----------
     PlateZone-style slideshow interaction:
       - Fade between slides (CSS handles transition)
       - Dots-only navigation by default (arrows hidden via .hero-arrows{display:none})
       - Auto pause on hover / focus / hidden tab
       - Touch/pointer swipe (>40px horizontal delta switches slide)
       - Reduced-motion: autoplay disabled, immediate slide swap
       - aria-hidden + aria-current updated per slide
       - Interval configurable via data-autoplay-interval (ms), defaults 7000 */
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousels() {
    $$('[data-carousel]').forEach(function (root) {
      var slides = $$('[data-slide]', root);
      var dots = $$('[data-dot]', root);
      var prev = $('[data-carousel-prev]', root);
      var next = $('[data-carousel-next]', root);
      if (slides.length < 1) return;
      var index = 0;
      var timer = null;
      var autoplay = root.hasAttribute('data-autoplay') && !prefersReducedMotion;
      var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10) || 7000;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          var active = n === index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (d, n) {
          var active = n === index;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
      function go(step) { show(index + step); restart(); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() {
        stop();
        if (!autoplay) return;
        timer = setInterval(function () { show(index + 1); }, interval);
      }

      on(prev, 'click', function () { go(-1); });
      on(next, 'click', function () { go(1); });
      dots.forEach(function (d, n) { on(d, 'click', function () { show(n); restart(); }); });

      /* Pause on hover / focus (keyboard accessibility) */
      on(root, 'mouseenter', stop);
      on(root, 'mouseleave', restart);
      on(root, 'focusin', stop);
      on(root, 'focusout', restart);
      /* Pause when tab not visible — saves CPU + battery */
      on(document, 'visibilitychange', function () {
        if (document.hidden) stop(); else restart();
      });

      /* Touch / pointer swipe — works for mouse, touch, pen */
      var dragStartX = null, dragStartY = null, dragLast = null;
      var SWIPE_THRESHOLD = 40;
      on(root, 'pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragStartX = e.clientX; dragStartY = e.clientY; dragLast = e.clientX;
        stop();
      });
      on(root, 'pointermove', function (e) {
        if (dragStartX === null) return;
        dragLast = e.clientX;
      });
      function endDrag() {
        if (dragStartX === null) { restart(); return; }
        var dx = (dragLast || dragStartX) - dragStartX;
        var dy = 0; /* vertical handled by browser via touch-action: pan-y */
        dragStartX = null; dragStartY = null; dragLast = null;
        if (Math.abs(dx) > SWIPE_THRESHOLD) {
          go(dx > 0 ? -1 : 1);
        } else {
          restart();
        }
      }
      on(root, 'pointerup', endDrag);
      on(root, 'pointercancel', endDrag);
      on(root, 'pointerleave', function () {
        if (dragStartX !== null) endDrag();
      });

      /* Keyboard left/right when slideshow is focused */
      on(root, 'keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1);  }
      });

      show(0);
      restart();
    });
  }

  /* ---------- Favourites (wishlist UI) ---------- */
  function initFavourites() {
    $$('[data-fav]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        btn.classList.toggle('is-active');
        btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var items = $$('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ---------- Plate search uppercase formatting ---------- */
  function initPlateInput() {
    $$('[data-plate-input]').forEach(function (input) {
      on(input, 'input', function () {
        var pos = input.selectionStart;
        input.value = input.value.toUpperCase();
        input.setSelectionRange(pos, pos);
      });
    });
  }

  /* ---------- Product / plate builder ---------- */
  function initProductBuilder() {
    var form = $('#PlateBuilderForm');
    if (!form) return;

    var dataEl = $('[data-variants]', form);
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }
    var idInput = $('[data-variant-id]', form);
    var priceEls = $$('[data-price]');
    var addBtn = $('[data-add-btn]', form);
    var optionInputs = $$('[data-option-input]', form);

    function money(cents) {
      return '£' + (cents / 100).toFixed(2);
    }

    function selectedOptions() {
      var opts = [];
      optionInputs.forEach(function (input) {
        if (input.checked) {
          opts[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
        }
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      })[0];
    }

    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      if (!variant) { variant = variants[0]; }
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      var priceHtml = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml = '<del>' + money(variant.compare_at_price) + '</del> ' + priceHtml;
      }
      priceEls.forEach(function (el) { el.innerHTML = priceHtml; });

      if (addBtn) {
        addBtn.disabled = !variant.available;
        var label = $('[data-add-label]', addBtn) || addBtn;
        label.textContent = variant.available ? 'Add to basket' : 'Sold out';
      }
    }

    optionInputs.forEach(function (input) {
      on(input, 'change', update);
    });

    var stickyAdd = $('[data-sticky-add]');
    if (stickyAdd && addBtn) {
      on(stickyAdd, 'click', function () { addBtn.click(); });
    }

    update();
  }

  /* ---------- Collection filters (mobile toggle) ---------- */
  function initCollectionFilters() {
    var toggle = $('[data-filters-toggle]');
    var filters = $('[data-filters]');
    if (!toggle || !filters) return;
    on(toggle, 'click', function () {
      filters.classList.toggle('is-open');
    });
  }

  function init() {
    initHeader();
    initMegaMenu();
    initDrawer();
    initSearch();
    initFaq();
    initCarousels();
    initFavourites();
    initReveal();
    initPlateInput();
    initProductBuilder();
    initCollectionFilters();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
